import { Alert, AlertTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StudioAiPreview } from "../hooks/useStudioAiEdit";
type StudioAIPreviewProps = {
  preview: StudioAiPreview;
};

// Why the AI preview could not be shown, above the canvas rather than over
// it. While it renders, StudioPreview's overlay covers the canvas; once
// painted, the live canvas is the preview.
export const StudioAIPreview = ({
  preview
}: StudioAIPreviewProps) => {
  const {
    t
  } = useTranslation();
  if (preview.status === "error") {
    return <Alert data-cy="StudioAIPreviewError" severity="warning" sx={{
      borderRadius: 0
    }}>
        <AlertTitle>{t("content.studioAiPreviewUnavailable")}</AlertTitle>
        {preview.message} {t("content.studioAiPreviewReviewHint")}
      </Alert>;
  }
  return null;
};